'use strict'

import React, { useContext, useEffect, useState } from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'
import PageContext from '../../Context/PageContext';
import { Popover } from '@blueprintjs/core';
import { createColorElementAction } from '../../history/color.history';

function SketchColor(props: any) {

    /* elem can be string : 'selectedItem' | 'page' */
    const elementToColor = props.elem;

    var initColor = props.color;
    const marker = props.marker;

    const { objItems, selectedItem, setPageColor, traceStyle, mapListEtape, elevationData, setElevationData, chartRef, history } = useContext(PageContext);

    const [color, setColor] = useState(initColor);
    const [isOpen, setIsOpen] = useState(false);
    const initialColorRef = React.useRef<string | null>(null);

    //save à l'ouverture
    /*useEffect(() => {
        if (isOpen) {
            initialColorRef.current = initColor;
        }
    }, [isOpen]);*/

    useEffect(() => {
        //utiliser pour les changement de couleurs quand on clic sur un element text
        setColor(props.color);
    }, [props.color]);

    //save à la fermeture
    /*useEffect(() => {

        //on gère la gestion de l'historique à l'ouverture et fermeture car on peut drag coulour dans la popop et ça ferait trop d'historique à gérer

        if (!isOpen && initialColorRef.current != null) {
            console.log('on passe là dans fermeture')
            const fromColor = initialColorRef.current;
            const toColor = color;

            if (fromColor !== toColor) {
                const action = createColorElementAction({
                    target: elementToColor,
                    itemId: selectedItem?.id,
                    fromColor,
                    toColor,
                    context: {
                        objItems,
                        selectedItem,
                        setPageColor,
                        traceStyle,
                        mapListEtape,
                        elevationData,
                        setElevationData,
                        chartRef,
                        marker
                    }
                });

                history.add(action);
            }

            initialColorRef.current = null;
        }
    }, [isOpen]);*/

    function handleChange(color: any) {
        if (elementToColor === 'selectedItem') {
            /* To set changed property to listItems*/
            const item = objItems.find(item => item.id === selectedItem.id);

            if (selectedItem != null) {
                if (item.type === "shape-element") selectedItem.querySelector('div').style.backgroundColor = color.hex;
                else selectedItem.style.color = color.hex;
            }
        }
        if (elementToColor === 'selectedItem-border') {
            /* To set changed property to listItems*/
            const item = objItems.find(item => item.id === selectedItem.id);

            if (selectedItem != null) {
                if (item.type === "shape-element") selectedItem.querySelector('div').style.borderColor = color.hex;
            }
        }
        if (elementToColor === 'page')
            if (setPageColor != null) setPageColor(color.hex);
        /*if (elementToColor === 'trace')
            traceColorChange(color.hex)*/
        if (elementToColor === "elevation-bg") {

            let copyJson = { ...elevationData };

            if (chartRef.current != null) {
                chartRef.current.ctx.fillStyle = color.hex;

                chartRef.current.data.datasets[0].backgroundColor = color.hex;

                if (setElevationData != null) setElevationData(copyJson);
                chartRef.current.update('none');
            }
        }
        if (elementToColor === "elevation-bordure") {

            let copyJson = { ...elevationData };

            if (chartRef.current != null) {

                chartRef.current.data.datasets[0].borderColor = color.hex;

                chartRef.current.update('none');
            }
            if (setElevationData != null) setElevationData(copyJson);
        }
        if (elementToColor === "marker-element-contour") {
            //var itemMakerLabel = marker.markerTxt.getElement();

            marker.markerTxtStyle['-webkit-text-stroke-color'] = color.hex;
        }

        setColor(color.hex);

    }

    function handleChangeComplete(color: any) {

        var fromColor = "";

        if (elementToColor === 'selectedItem') {
            /* To set changed property to listItems*/
            const item = objItems.find(item => item.id === selectedItem.id);

            if (selectedItem != null) {
                fromColor = item.style.color;
                item.style.color = color.hex;
            }
        }
        if (elementToColor === 'selectedItem-border') {
            /* To set changed property to listItems*/
            const item = objItems.find(item => item.id === selectedItem.id);

            if (selectedItem != null) {
                fromColor = item.style["border-color"];
                item.style["border-color"] = color.hex;
            }
        }
        if (elementToColor === "elevation-bg") {

            let copyJson = { ...elevationData };

            fromColor = copyJson.datasets[0].backgroundColor;

            copyJson.datasets[0].backgroundColor = color.hex;

            if (chartRef.current != null) {

                chartRef.current.ctx.fillStyle = color.hex;

                chartRef.current.data.datasets[0].backgroundColor = color.hex;

                if (setElevationData != null) setElevationData(copyJson);
                chartRef.current.update('none');
            }
        }
        if (elementToColor === "elevation-bordure") {

            let copyJson = { ...elevationData };

            fromColor = copyJson.datasets[0].borderColor;

            copyJson.datasets[0].borderColor = color.hex;

            if (chartRef.current != null) {
                chartRef.current.data.datasets[0].borderColor = color.hex;

                chartRef.current.update('none');
            }
            if (setElevationData != null) setElevationData(copyJson);
        }
        if (elementToColor === "marker-element-contour") {
            var itemMakerLabel = marker.markerTxt.getElement();

            fromColor = itemMakerLabel.style['-webkit-text-stroke-color'];
            marker.markerTxtStyle['-webkit-text-stroke-color'] = color.hex;
            itemMakerLabel.style['-webkit-text-stroke-color'] = color.hex;

        }


        const toColor = color.hex;
        //console.log(fromColor)
        //console.log(toColor)

        if (fromColor !== toColor) {
            const action = createColorElementAction({
                target: elementToColor,
                itemId: selectedItem?.id,
                fromColor,
                toColor,
                context: {
                    objItems,
                    selectedItem,
                    setPageColor,
                    traceStyle,
                    mapListEtape,
                    elevationData,
                    setElevationData,
                    chartRef,
                    marker
                }
            });

            history.add(action);
        }

        initialColorRef.current = null;

        setColor(color.hex);

    }

    //trace color not handle here
    /*function traceColorChange(color: any) {
        var map = (window as any).$map;

        console.log("on passe là")

        if (traceStyle != null) {
            traceStyle["line-color"] = color;

            var layers = map.getStyle().layers

            //get only id val from
            const mapId = mapListEtape.map((x) => x.id);
            const myLayers = layers.filter((x: any) => mapId.includes(x.id));

            myLayers.forEach((element: any) => {
                map.setPaintProperty(element.id, "line-color", color)
            });
        }
    }*/

    const styles = reactCSS({
        'default': {
            color: {
                width: '30px',
                height: '30px',
                borderRadius: '50%',
                background: `${color}`,
            },
            swatch: {
                //padding: '5px',
                background: '#fff',
                //borderRadius: '1px',
                borderRadius: '50%',
                width: '30px', height: '30px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
            },
        },
    });

    const eleMColor = () => {

        return (
            <div>
                <SketchPicker
                    color={color}
                    onChange={handleChange}
                    disableAlpha={true}
                    onChangeComplete={handleChangeComplete} />
            </div>
        )
    }


    return (
        <div>
            <Popover content={eleMColor()} placement="bottom"
                isOpen={isOpen}
                onInteraction={(nextOpenState) => setIsOpen(nextOpenState)}>
                <div className='text-color-picker' style={styles.swatch}>
                    <div style={styles.color} />
                </div>
            </Popover>
        </div>
    )

}

export default SketchColor